import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  standalone: true,
  imports: [MatDialogModule, MatButton],
  template: `<div class="dialog__header">
      <h1 class="dialog__title" mat-dialog-title>Contact Upated</h1>
      <mat-icon mat-button mat-dialog-close class="dialog__icon dialog__close" fontIcon="close"></mat-icon>
    </div>
    <mat-dialog-content>
      <p>The contact details were updated successfully. Please allow up to 5 minutes for the changes to appear against the contact.</p>
      <p>Please email support if the changes against the contact are not reflected within 24 hours.</p>
      <mat-dialog-actions>
        <div>
          <button tabindex="-1" mat-raised-button [mat-dialog-close]="true">Ok</button>
        </div>
      </mat-dialog-actions>
    </mat-dialog-content>`,
})
export class AccountEditContactSuccessComponent {}
